import React from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
    return (
        <div className="min-h-screen flex items-center justify-center bg-ares-void px-6">
            <div className="w-full max-w-md text-center rounded-2xl border border-ares-border bg-ares-dark/90 p-10 fade-up" data-testid="payment-cancel-card">
                <div className="w-16 h-16 rounded-full bg-ares-muted/15 border border-ares-border flex items-center justify-center mx-auto mb-5">
                    <XCircle className="w-8 h-8 text-ares-muted" />
                </div>
                <h1 className="font-heading text-2xl font-semibold">Checkout canceled</h1>
                <p className="text-ares-muted mt-2 text-sm">No charge was made. You can start your free trial whenever you're ready.</p>
                <Link to="/app"><Button className="mt-6 h-11 bg-ares-orange hover:bg-[#e55a2b] text-white px-8" data-testid="cancel-back-btn">Back to Console</Button></Link>
            </div>
        </div>
    );
}
